import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { browserHistory as history } from 'react-router';
import moment from "moment";
import 'moment-duration-format';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { arrayIsNotEmpty, formatDate, isDefined, sortReactTable } from '../../../../../utils';
import { columnsAccessors } from '../../../../../constants';
import FilterIcon from '../../../../../icons/FilterIcon';
import FilterIconBack from '../../../../../icons/FilterIconBack';
import CloseFilterIcon from '../../../../../icons/CloseFilterIcon';
import QaQuestionResponseModal from '../../../../../components/v3/Coaching/QaQuestionResponseModal';

import {
    updateProps,
    loadQaSurveyFormQuestions,
    deleteAudit
} from '../../QaDashboardScreenActions';

class AgentAuditsSummary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showHelpPopup: false,
            showAllResponsesPopUp: false,
            searchTeamQuery: undefined,
            selectedTeamFilter: undefined,
            showFiltersHeader: false,

            showAvgBiasFilterPopup: false,
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined,

            searchChannelOrInteractionIdQuery: undefined,

            hoveredRowId: undefined,
            deletedSurveyId: []
        };

        this.showHelpPopup = this.showHelpPopup.bind(this);
        this.closeHelpPopup = this.closeHelpPopup.bind(this);

        this.showAllResponsesPopUp = this.showAllResponsesPopUp.bind(this);
        this.hideAllResponsesPopUp = this.hideAllResponsesPopUp.bind(this);

        this.hideFiltersHeader = this.hideFiltersHeader.bind(this);
        this.showFiltersHeader = this.showFiltersHeader.bind(this);

        this.getTableColumns = this.getTableColumns.bind(this);

        this.getAllResponsesPopUp = this.getAllResponsesPopUp.bind(this);

        this.deleteAudit = this.deleteAudit.bind(this);
        //this.setHoveredRow = this.setHoveredRow.bind(this);
        this.goToCoaching = this.goToCoaching.bind(this);
    }

    //setHoveredRow(hoveredRowId) {
    //    this.setState({ hoveredRowId: hoveredRowId });
    //}

    showHelpPopup(e) {
        this.setState({ showHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeHelpPopup() {
        this.setState({ showHelpPopup: false });
    }

    showAllResponsesPopUp(surveyId) {
        const {
            selectedQaSurveyform
        } = this.props;
        this.props.dispatch(loadQaSurveyFormQuestions(selectedQaSurveyform.id));
        this.setState({ showAllResponsesPopUp: true, selectedSurveyId: surveyId });
    }

    hideAllResponsesPopUp() {
        this.setState({ showAllResponsesPopUp: false });
    }

    // Show hide filter functions
    showFiltersHeader() {
        this.setState({ showFiltersHeader: true });
    }

    hideFiltersHeader() {
        this.setState({
            showFiltersHeader: false,
            searchChannelOrInteractionIdQuery: undefined,
            searchTeamQuery: undefined,
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined
        });
    }

    ////////////////////////////////////////////////////

    getTableColumns() {
        const
            {
                selectedQaSurveyform,
            } = this.props;

        if (this.state.showFiltersHeader) {
            //rfcHeader = (<div className="table-header-filter min-max-type" onClick={this.showSelectReasonsForContactPopup}>RFC</div>);;
        }

        const columns = [];

        let interactionHeader = 'Ticket';
        columns.push(
            {
                Header: interactionHeader,
                accessor: columnsAccessors.interactionExternalIdNode
            }
        );

        columns.push(
            {
                //Header: 'Last Coaching Date',
                Header: 'Audit Date',
                accessor: 'auditDate'
            });

        columns.push(
            {
                //Header: 'Last Coaching Date',
                Header: 'Contact Reason',
                accessor: 'reasonForContact'
            });

        let maxSurveyFormPoints = 0;
        if (selectedQaSurveyform && selectedQaSurveyform.qaSectionInfos && Array.isArray(selectedQaSurveyform.qaSectionInfos)) {
            selectedQaSurveyform.qaSectionInfos.forEach(section => {
                columns.push(
                    {
                        Header: `${section.sectionName} (${section.sectionMaxScore})`,
                        accessor: `${section.sectionName}`,
                        //width: 180
                    }
                );
                maxSurveyFormPoints = maxSurveyFormPoints + section.sectionMaxScore;
            });
        }


        columns.push(
            {
                //Header: 'Last Coaching Date',
                Header: `Sum Audit Score (${maxSurveyFormPoints})`,//'Sum Audit Score',
                accessor: `sumAuditScore`
            });
        columns.push(
            {
                Header: ' ',
                accessor: columnsAccessors.k,
                width: 60
            });
        return columns;
    }

    goToCoaching(agent) {
        history.push(`/QualityAssurance/status/coach/${agent.agentId}`);
        this.props.dispatch(updateProps({ selectedAgentToCoach: agent }));
    }

    deleteAudit() {
        //const
        //    {
        //        completedAuditsDetails,
        //    } = this.props;
        this.state.deletedSurveyId.push(this.state.selectedSurveyId);
        this.setState({ showAllResponsesPopUp: false });//, deletedSurveyId: this.state.selectedSurveyId
        this.props.dispatch(deleteAudit(this.state.selectedSurveyId));
        //var newCompletedAuditsDetails = completedAuditsDetails.filter(a => a.surveyId !== this.state.selectedSurveyId);
        //this.props.dispatch(updateProps({ completedAuditsDetails: newCompletedAuditsDetails }));
    }

    getAllResponsesPopUp() {
        const
            {
                completedAuditsDetails,
                qaSurveyFormQuestions
            } = this.props;

        if (!completedAuditsDetails || completedAuditsDetails.length < 1)
            return;

        const surveyFormQuestions = completedAuditsDetails.find(a => a.surveyId === this.state.selectedSurveyId);
        const surveyFields = surveyFormQuestions ? surveyFormQuestions.surveyFields : undefined;
        const comment = surveyFormQuestions ? surveyFormQuestions.comment : undefined;

        return (<div className="modal displayBlock" >
            <div className="modal-content">
                <QaQuestionResponseModal
                    deleteAudit={this.deleteAudit}
                    comment={comment}
                    qaSurveyFormQuestions={qaSurveyFormQuestions}
                    options={surveyFields}
                    onClose={this.hideAllResponsesPopUp} />
            </div>
        </div>);
    }

    render() {
        const
            {
                selectedAgentToCoach,
                selectedQaSurveyform,
                completedAuditsDetails,
                currentAgentTeamQaScore
            } = this.props;


        let result = {};
        result.columns = this.getTableColumns();
        const completedAuditsDetailsToShow = this.state.deletedSurveyId.length > 0
            ? completedAuditsDetails.filter(a => !this.state.deletedSurveyId.includes(a.surveyId))//item => !secondArray.includes(item.id)
            : completedAuditsDetails;
        const auditCount = completedAuditsDetailsToShow ? `(${completedAuditsDetailsToShow.length} Audits)` : '';
        const agentQaSurveyCount = selectedAgentToCoach ? `${selectedAgentToCoach.agentName} ${auditCount}` : '';

        const loading = !isDefined(completedAuditsDetailsToShow) || !isDefined(selectedAgentToCoach) || !isDefined(selectedQaSurveyform);
        if (loading === true) {
            return (
                <div>
                    <div className="teams-table-for-manager filters-wrapper" style={{ margin: '0 0 22px 0' }}>
                        <div className="teams-table-for-manager filter-area-title-wrapper">
                            <label className="teams-table-for-manager all-teams-title">
                                {agentQaSurveyCount}
                            </label>
                        </div>
                    </div>
                    <ReactTable
                        columns={result.columns}
                        defaultPageSize={10}
                        loading={loading}
                        className="-striped -highlight" />
                </div>);
        }

        result.data = completedAuditsDetailsToShow;

        let agentAverageQaScore = 0;
        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (selectedQaSurveyform && selectedQaSurveyform.qaSectionInfos && Array.isArray(selectedQaSurveyform.qaSectionInfos)) {
                    let sumAuditScore = 0;
                    selectedQaSurveyform.qaSectionInfos.forEach(section => {
                        if (arrayIsNotEmpty(row.qaSectionScoresInfo)) {
                            const currentSection = row.qaSectionScoresInfo.find(sectionInfo => sectionInfo.sectionId === section.sectionId);
                            if (isDefined(currentSection)) {
                                sumAuditScore = sumAuditScore + currentSection.sectionAverageScore;
                                row[`${section.sectionName}`] = <div>
                                    {currentSection.sectionAverageScore}
                                </div>;
                            }
                        }
                    });

                    row.sumAuditScore = sumAuditScore;
                    agentAverageQaScore = agentAverageQaScore + sumAuditScore;
                }

                if (isDefined(row.auditDate)) {
                    row.auditDate = formatDate(row.auditDate);
                }

                row.interactionExternalIdNode = row.externalTicketNumber;

                if (isDefined(row.externalNumber)) {
                    let channelIcon;
                    if (isDefined(row.channelType)) {
                        if (row.channelType.toLowerCase() == 'voice' || row.channelType.toLowerCase() == 'phone') {
                            channelIcon = <CallChannelIcon />
                        }
                        else if (row.channelType.toLowerCase() == 'chat') {
                            channelIcon = <ChatChannelIcon />
                        }
                        else if (row.channelType.toLowerCase() == 'email') {
                            channelIcon = <EmailChannelIcon />
                        }
                        else {
                            channelIcon = <div className="icon-square">{row.channelType}</div>
                        }
                    }
                    else {
                        channelIcon = <div className="icon-square">--</div>
                    }
                    row.interactionExternalIdNode =
                        (<div className="flex-container-center">
                            <div style={{ minWidth: '20px' }}>
                                {channelIcon}
                            </div>
                            <div style={{ margin: "0 0 0 10px" }}>{row.externalNumber}</div>
                        </div>)
                }

                //row.coachingAction = <div>Not Coached </div>;
                //if (row.agentId === this.state.hoveredRowId) {
                //    row.coachingAction = <div className="v3-button agent-view-interactions"
                //        style={{ width: '100px', background: '#32A6AE', padding: '13px' }}
                //        onClick={() => this.goToCoaching(row)}>
                //        Coach
                //    </div>
                //}
            });
        }

        agentAverageQaScore = result.data.length > 0 ? parseInt(agentAverageQaScore / (result.data.length)) : 0;

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="interactions -striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            this.showAllResponsesPopUp(rowInfo.original.surveyId)
                        },
                        //onMouseEnter: () => {
                        //    this.setHoveredRow(rowInfo.original.agentId)
                        //},
                        //onMouseLeave: () => {
                        //    this.setHoveredRow(null)
                        //},
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        const allResponsesPopUp = this.state.showAllResponsesPopUp ? this.getAllResponsesPopUp() : undefined;

        const teamScore = isDefined(currentAgentTeamQaScore) ? currentAgentTeamQaScore.averageScore : '';
        const teamName = isDefined(currentAgentTeamQaScore) ? currentAgentTeamQaScore.teamName : '';

        return (
            <div>
                <div className="teams-table-for-manager filters-wrapper" style={{ margin: '0 0 22px 0' }}>
                    <div>
                        <div>
                            <label className="teams-table-for-manager all-teams-title">
                                {agentQaSurveyCount} - Average Qa Score: {agentAverageQaScore}
                            </label>
                        </div>
                        <div>
                            <label className="teams-table-for-manager all-teams-title">
                                {teamName} Average Score: {teamScore}
                            </label>
                        </div>
                    </div>
                </div>
                {allResponsesPopUp}
                <div style={{ position: 'relative', zIndex: 0 }}>
                    {!this.state.showFiltersHeader &&
                        <div onClick={this.showFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 2,
                            right: '0',
                            cursor: 'pointer'
                        }}>
                            <FilterIconBack />
                        </div>}
                    {!this.state.showFiltersHeader &&
                        <div onClick={this.showFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 3,
                            right: '0',
                            cursor: 'pointer'
                        }}>
                            <FilterIcon />
                        </div>}

                    {this.state.showFiltersHeader &&
                        <div onClick={this.hideFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 2,
                            right: '9px',
                            top: '9px',
                            cursor: 'pointer'
                        }}>
                            <CloseFilterIcon />
                        </div>}
                    {teamsResultTable}
                </div>
            </div>);
    };
}

const select = state => ({ ...state.QaDashboardManagerScreen });
export default connect(select)(AgentAuditsSummary);

